export type EnvName = "local" | "dev" | "staging" | "prod";

export interface EnvironmentConfig {
  name: EnvName;
  apiUrl: string;
  isElevatedRisk: boolean;
  confirmText: string;
  display: {
    label: string;
    accentClass: string;
    badgeClass: string;
  };
}

const ENV_CONFIGS: Record<EnvName, Omit<EnvironmentConfig, "apiUrl">> = {
  local: {
    name: "local",
    isElevatedRisk: false,
    confirmText: "",
    display: {
      label: "LOCAL",
      accentClass: "",
      badgeClass: "bg-foreground-muted/10 text-foreground-muted",
    },
  },
  dev: {
    name: "dev",
    isElevatedRisk: true,
    confirmText: "DEV",
    display: {
      label: "DEV",
      accentClass: "border-t-2 border-t-warning",
      badgeClass: "bg-warning-background text-warning",
    },
  },
  staging: {
    name: "staging",
    isElevatedRisk: true,
    confirmText: "STAGING",
    display: {
      label: "STAGING",
      accentClass: "border-t-2 border-t-foreground-accent",
      badgeClass: "bg-foreground-accent/10 text-foreground-accent",
    },
  },
  prod: {
    name: "prod",
    isElevatedRisk: true,
    confirmText: "PRODUCTION",
    display: {
      label: "PRODUCTION",
      accentClass: "border-t-2 border-t-error",
      badgeClass: "bg-error-background text-error",
    },
  },
} as const;

function resolveEnvName(): EnvName {
  const raw = import.meta.env.VITE_ENV_NAME;
  if (raw === "local" || raw === "dev" || raw === "staging" || raw === "prod") return raw;
  return "local";
}

export function resolveEnvironment(): EnvironmentConfig {
  const name = resolveEnvName();
  const apiUrl = import.meta.env.VITE_API_URL ?? "";
  return { ...ENV_CONFIGS[name], apiUrl };
}
